import { render, staticRenderFns } from "./routingComponent.vue?vue&type=template&id=25b11fa7"
import script from "./routingComponent.vue?vue&type=script&lang=js"
export * from "./routingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports